import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { CostWithDiscount } from 'server/detail-requests/ShippingCost';
import classes from './index.module.scss';
export type CostWithDiscountProps = {
  costWithDiscount: CostWithDiscount;
};
export const DiscountedCost = t0 => {
  const $ = _c(7);
  const {
    costWithDiscount
  } = t0;
  let t1;
  if ($[0] !== costWithDiscount.strikethroughCost) {
    t1 = costWithDiscount.strikethroughCost && <p className={classNames("body-text", "small", classes.strikePrice)}>{costWithDiscount.strikethroughCost}</p>;
    $[0] = costWithDiscount.strikethroughCost;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${costWithDiscount.partial ? "da " : ""}${costWithDiscount.cost}`;
  let t3;
  if ($[2] !== t2) {
    t3 = <p className="body-text semibold">{t2}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <div className={classes.costWithDiscount}>{t1}{t3}</div>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};